import React, { useEffect, useState } from "react";
import "./layout.css";
import utils from "../../../utils/utils";
import ButtonComponent from "../button/authButton";
import DropDownMenu from "../dropdown/dropdownMenu";
import { _authenticateUser } from "../../../redux/actions/authAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useIsAdmin from "../../../hooks/useIsAdmin";
import { _setMyInfo } from "../../../redux/actions/generalAction";

function Header() {
  const isAdmin = useIsAdmin();
  const userdata = useSelector(
    (state) => state.settings_data.profileSettings_data
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const privileges = useSelector((state) => state.auth?.privileges);
  const showSubscription = !privileges?.onPremises && isAdmin;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    dispatch(_authenticateUser(false));
    dispatch(_setMyInfo(null));
    setAnchorEl(null);
  };

  const handleUpdatePassword = () => {
    navigate("/update-password");
    setAnchorEl(null);
  };

  const handleUpdateProfile = () => {
    navigate("/update-profile");
    setAnchorEl(null);
  };

  const handleSubscriptions = () => {
    navigate("/subscription");
    setAnchorEl(null);
  };

  const handleContactUs = () => {
    navigate("/contact-us");
    setAnchorEl(null);
  };
  const handleUpdateWorkSpace = () => {
    navigate("/update-workspace");
    setAnchorEl(null);
  };

  return (
    <>
      <div className="header-container">
        <div>
          <img
            src={utils.icons.Dentalid_logo}
            alt="logo"
            onClick={() => navigate("/")}
          />
        </div>
        <div>
          <p>{userdata?.name}</p>
          <div onClick={handleClick}>
            <img
              src={utils.icons.userAccount}
              height={23}
              width={23}
              alt="user-Account"
              className="rounded-full h-[23px] w-[23px]"
            />
          </div>
        </div>
      </div>
      <DropDownMenu
        open={open}
        anchorEl={anchorEl}
        handleClose={handleClose}
        handleLogout={handleLogout}
        handleUpdatePassword={handleUpdatePassword}
        handleUpdateProfile={handleUpdateProfile}
        handleSubscriptions={handleSubscriptions}
        handleContactUs={handleContactUs}
        showSubscription={showSubscription}
        isAdmin={isAdmin}
        handleUpdateWorkSpace={handleUpdateWorkSpace}
      />
    </>
  );
}

export default Header;
